import { render, staticRenderFns } from "./ModeloProjeto.vue?vue&type=template&id=0357257a&"
import script from "./ModeloProjeto.vue?vue&type=script&lang=js&"
export * from "./ModeloProjeto.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports